import SubVisual from '@/components/SubVisual';
import SectionCont1 from '@/pages/why/components/SectionCont1';
import SectionCont2 from '@/pages/why/components/SectionCont2';
import SectionCont3 from '@/pages/why/components/SectionCont3';
import SectionCont4 from '@/pages/why/components/SectionCont4';
import SectionCont5 from '@/pages/why/components/SectionCont5';
import useScrollReset from '@/hooks/useScrollReset';

const WhyPage = () => {
	useScrollReset();
	return (
		<main id="sub" className="sub why">
			<SubVisual cate={'서비스 소개'} title={'Why Stella Now?'} />
			<SectionCont1 />
			<SectionCont2 />
			<SectionCont3 />
			<SectionCont4 />
			<SectionCont5 />
		</main>
	);
};

export default WhyPage;
